module.exports = __webpack_public_path__ + "img/18crij.7f62b261.png";